export const rtNamespace = 'Toastify'
export const rtToastWidth = '470px'
export const rtToastBackground = '#ffffff'
export const rtToastMinHeight = '64px'
export const rtToastMaxHeight = '800px'

export const rtMobile = "'only screen and (max-width : 480px)'"
export const rtZIndex = '99999'
